import axios from 'axios';
import React, { useEffect, useState,useRef,useContext } from 'react'
import Card from '@mui/material/Card';
import Document from '../../Images/Docs.png'
import DocumentViewer from '../Vendors/DocumentViewer';
import { FormControlLabel, Tab, Tabs,TextField, Typography, Box, Switch, Select, MenuItem, FormControl, InputLabel,Modal,Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { UserContext } from '../../App';
import AuthErrorPop from '../Util/AuthErrorPop';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  
const EditHandle = ({ open, onClose, editvalue, updateDetails, value }) => {
    const [error, setError] = useState('')
    const erroRef = useRef()
    const [inputValue, setValue] = useState(value)

    // console.log(value)
    const handleSubmit = () => {
            if (editvalue === 'Invoice Email') {
                    updateDetails(inputValue)
                    setValue('')
            } else {
                    updateDetails(inputValue)
                    setValue('')
            }
    }

    useEffect(() => {
        
          setValue(value)
        

            //console.log(inputValue)
    }, [value, open])


    const style = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '1px solid lightblue',
          boxShadow: 24,
          p: 4,
    };

return (
  <Modal
    open={open}
    onClose={onClose}
    aria-labelledby="parent-modal-title"
    aria-describedby="parent-modal-description"
  >
          <Box sx={{ ...style }}>

              <div className='pop-edit'>
                     <div className='text-red-500' style={{ textAlign: 'center', fontSize: '23px', marginBottom: '30px', color: 'darkblue' }}>Edit {editvalue}</div>
                       <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                            {editvalue === 'Account Type' ?
                              <FormControl style={{ marginLeft: '50px', width: '300px', }} >
                                <InputLabel id="demo-simple-select-label">ACCOUNT TYPE</InputLabel>
                                <Select sx={{ paddingLeft: '10px', }}
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={inputValue}
                                  label='ACCOUNT TYPE'
                                  onChange={(e) => { setValue(e.target.value) }}
                                >
                                  <MenuItem value='Saving'>SAVING</MenuItem>
                                  <MenuItem value='Current'>CURRENT</MenuItem>

                                </Select>
                              </FormControl> : 
                              <TextField className='edit-label' value={inputValue} onChange={(event) => {
                                setValue(event.target.value)
                                erroRef.current.innerHTML = ''
                              }} id="outlined-basic" label={editvalue} variant="outlined" />
                            }
                       </div>
                    <div style={{ textAlign: 'center', color: 'red' }} ref={erroRef}></div>
                    <div style={{ textAlign: 'center', marginBottom: '5px', marginTop: '30px', }}>
                            <Button sx={{ marginRight: '30px', fontSize: '13px' }} onClick={() => {
                              setValue('')
                              onClose()
                            }} variant="contained">Close</Button>
                            <Button sx={{ fontSize: '13px' }} onClick={handleSubmit} variant="contained">Save</Button>
                    </div>
                  </div>

          </Box>
  </Modal>
)
}


function RadPayment({ radId }) {
    const [paymentInfo, setPaymentInfo] = useState(null)
    const [open, setOpen] = useState(false)
    const {handleAccess,accessLevel}=useContext(UserContext);
    const [editTab, setEditTab] = useState(false)
    const [editvalue, setValue] = useState('')
    const [invoiceAPIValue, setInvoiceAPIValue] = useState('')
    const [authPop, setAuthPop] = useState(false)
    const [alert, setAlert] = useState(false);
    const [errorAlert, setErrorAlert] = useState(false)

    const radPaymentInfo = async () => {
        const { REACT_APP_RAD_PAYMENT_INFO,REACT_APP_ADMIN_API_AUTH } = process.env
        const res = await axios.get(REACT_APP_RAD_PAYMENT_INFO + `${radId}`,{
          headers: {
            Authorization:REACT_APP_ADMIN_API_AUTH
          }
        })
        if (res?.status === 200) {
            setPaymentInfo(res?.data)
        }
    }

    const updateDetails = async(value)=>{
        try {
            setEditTab(false)
                    var body;
                    if (editvalue === 'Account Holder Name') {
                      body = {
                        "name_of_account_holder": value
                      }
                    }
                    else if (editvalue === 'Account Number') {

                     
                      body = {
                        "account_number": value
                      }
                    }
                    else if (editvalue === 'IFSC Number') {
                      body = {
            
                        "ifsc": value
                      }
                    }
                    else if (editvalue === 'Account Type') {

                      body = {
               
                        "account_type": value
                      }
                    }
                    else if (editvalue === 'Bank Name') {

                      body = {
                        
                        "bank_name": value
                      }
                    }
                    else if (editvalue === 'Billing Address') {

                      body = {
              
                        "billing_address": value
                      }
                    }

                    else if (editvalue === 'Payment Date') {

                        body = {
                
                          "payment_date": value
                        }
                      }
                    else if (editvalue === 'Pan') {

                      body = {
                
                        "pan": value
                      }
                    }

                    //console.log(body)
                    const { REACT_APP_RAD_PAYMENT_INFO,REACT_APP_ADMIN_API_AUTH } = process.env
                    const res = await axios.put(REACT_APP_RAD_PAYMENT_INFO + `${radId}`,
                      body,
                      {
                        headers: {
                          Authorization:REACT_APP_ADMIN_API_AUTH
                        }
                      }
                    )
                    if (res.status === 200) {
                      setAlert("Updated Successfully")
                    
                    }
                    else {
                      setErrorAlert(true)
                    }
                    //console.log(body)

            
          
      } catch (err) {
              console.log(err)
              setErrorAlert(true)
      } finally {
        radPaymentInfo()
        // setPopUp(false)
      }

    }


    useEffect(() => {
        if (radId) {
            radPaymentInfo();
        }
    }, [radId]);


    return (
        <div className='details-container'>
            <div >

                <div class="card">
                    <div><strong>Account Holder Name :</strong></div>
                    <div className='card-inside'>
                        <div>{paymentInfo?.payment_details?.name_of_account_holder}</div>
                        <div><EditIcon style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                if(handleAccess('Radiologist','Edit Payment')===true){
                                                  setValue('Account Holder Name')
                                                  setInvoiceAPIValue(paymentInfo?.payment_details?.name_of_account_holder)
                                                  setEditTab(true)
                                                }
                                                else {
                                                  setAuthPop(true)
                                                }

                                              }} /></div>
                    </div>
                </div>

                <div class="card">
                    <div><strong>Account Number :</strong></div>
                    <div className='card-inside'>
                    <div>{paymentInfo?.payment_details?.account_number}</div>
                        <div><EditIcon  style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                                  if(handleAccess('Radiologist','Edit Payment')===true){
                                                                    setValue('Account Number')
                                                                    setInvoiceAPIValue(paymentInfo?.payment_details?.account_number)
                                                                    setEditTab(true)
                                                                  }
                                                                  else {
                                                                    setAuthPop(true)
                                                                  }

                                                                }} /></div>
                    </div>
                    
                </div>

                <div class="card">
                    <div><strong>IFSC Number :</strong></div>
                
                    <div className='card-inside'>
                    <div>{paymentInfo?.payment_details?.ifsc}</div>
                        <div><EditIcon style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                if(handleAccess('Radiologist','Edit Payment')===true){
                                                  setValue('IFSC Number')
                                                  setInvoiceAPIValue(paymentInfo?.payment_details?.ifsc)
                                                  setEditTab(true)
                                                }
                                                else {
                                                  setAuthPop(true)
                                                }

                                              }} /></div>
                    </div>
                </div>
                <div class="card">
                    <div><strong>Account Type :</strong></div>
                    
                    <div className='card-inside'>
                    <div>{paymentInfo?.payment_details?.account_type}</div>
                        <div><EditIcon style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                if(handleAccess('Radiologist','Edit Payment')===true){
                                                  setValue('Account Type')
                                                  setInvoiceAPIValue(paymentInfo?.payment_details?.account_type)
                                                  setEditTab(true)
                                                }
                                                else {
                                                  setAuthPop(true)
                                                }

                                              }} /></div>
                    </div>
                </div>

                <div class="card">
                    <div><strong>Bank Name :</strong></div>
                   
                    <div className='card-inside'>
                    <div>{paymentInfo?.payment_details?.bank_name}</div>
                        <div><EditIcon style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                if(handleAccess('Radiologist','Edit Payment')===true){
                                                  setValue('Bank Name')
                                                  setInvoiceAPIValue(paymentInfo?.payment_details?.bank_name)
                                                  setEditTab(true)
                                                }
                                                else {
                                                  setAuthPop(true)
                                                }

                                              }} /></div>
                    </div>
                </div>
                <div class="card">
                    <div><strong>Billing Address :</strong></div>
                    
                    <div className='card-inside'>
                    <div>{paymentInfo?.payment_details?.billing_address}</div>
                        <div><EditIcon style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                if(handleAccess('Radiologist','Edit Payment')===true){
                                                  setValue('Billing Address')
                                                  setInvoiceAPIValue(paymentInfo?.payment_details?.billing_address)
                                                  setEditTab(true)
                                                }
                                                else {
                                                  setAuthPop(true)
                                                }

                                              }} /></div>
                    </div>
                </div>

                <div class="card">
                    <div><strong>Payment Date :</strong></div>
                   
                    <div className='card-inside'>
                    <div>{paymentInfo?.payment_details?.payment_date}</div>
                        <div><EditIcon style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                if(handleAccess('Radiologist','Edit Payment')===true){
                                                  setValue('Payment Date')
                                                  setInvoiceAPIValue(paymentInfo?.payment_details?.payment_date)
                                                  setEditTab(true)
                                                }
                                                else {
                                                  setAuthPop(true)
                                                }

                                }} /></div>
                    </div>
                </div>

            </div>

            <div style={{ width: '50%' }}>

               

                <div class="card">
                    <div><strong>PAN Number & Document :</strong></div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className='card-inside'>
                    <div>{paymentInfo?.payment_details?.pan}</div>
                        <div><EditIcon style={{ marginTop: '-5px', color: 'black' }} onClick={() => {
                                                
                                                if(handleAccess('Radiologist','Edit Payment')===true){
                                                  setValue('Pan')
                                                  setInvoiceAPIValue(paymentInfo?.payment_details?.pan)
                                                  setEditTab(true)
                                                }
                                                else {
                                                  setAuthPop(true)
                                                }

                                }} /></div>
                    </div>
                        {paymentInfo?.payment_details?.pan_image && <div style={{ marginTop: '10px' }}>
                            <a href={paymentInfo?.payment_details?.pan_image} target='blank'>
                                <img width={60} src={Document} />
                            </a>
                        </div>
                        }
                    </div>
                </div>

                <div class="card">
                    <div><strong>Aadhar Document :</strong></div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {paymentInfo?.payment_details?.aadhar_image && <div style={{ marginTop: '10px' }}>
                            <a href={paymentInfo?.payment_details?.aadhar_image} target='blank'>
                                <img width={60} src={Document} />
                            </a>
                        </div>
                        }
                    </div>
                </div>
                <div class="card">
                    <div><strong>Check Image :</strong></div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {paymentInfo?.payment_details?.cheque_image && <div style={{ marginTop: '10px' }}>
                            <a href={paymentInfo?.payment_details?.cheque_image} target='blank'>
                                <img width={60} src={Document} />
                            </a>

                        </div>
                        }
                    </div>
                </div>



            </div>
            <EditHandle open={editTab} editvalue={editvalue} onClose={() => setEditTab(false)} value={invoiceAPIValue} updateDetails={updateDetails} />

            <DocumentViewer open={open} setOpen={setOpen} />

            <Snackbar open={alert} sx={{ top: '50px !important' }} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={() => { setAlert(false) }}>
                            <Alert onClose={() => { setAlert(false) }} severity="success" sx={{ width: '100%' }}>
                              Updated Successfully
                            </Alert>
                          </Snackbar>

                          <Snackbar open={errorAlert} sx={{ top: '50px !important' }} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={() => { setErrorAlert(false) }}>
                            <Alert onClose={() => { setErrorAlert(false) }} severity="error" sx={{ width: '100%' }}>
                              {errorAlert === true ? 'Updation Failed' : errorAlert}
                            </Alert>
                          </Snackbar>

                          <AuthErrorPop authPop={authPop} setAuthPop={setAuthPop} />
        </div>
    )
}

export default RadPayment
